import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RateLimitService, RateLimitState } from '../../services/rate-limit.service';

@Component({
  selector: 'app-rate-limit-overlay',
  templateUrl: './rate-limit-overlay.component.html',
  styleUrls: ['./rate-limit-overlay.component.scss']
})
export class RateLimitOverlayComponent implements OnInit, OnDestroy {
  isVisible = false;
  timeRemaining = 0;
  isHome = false;
  private subscription: Subscription;

  @Output() visibilityChange = new EventEmitter<boolean>();

  constructor(
    private rateLimitService: RateLimitService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // console.log('🚫 [RateLimitOverlay] Componente inicializado');

    // Suscribirse a los cambios de estado del rate limiting
    this.subscription = this.rateLimitService.rateLimitState$.subscribe(
      (state: RateLimitState) => {
       // console.log('🚫 [RateLimitOverlay] Estado recibido:', state);

        if (state.isActive && state.timeRemaining > 0) {
          this.isVisible = true;
          this.timeRemaining = state.timeRemaining;
          this.isHome = state.isHome;
          this.visibilityChange.emit(true); // Notificar que está visible

          // console.log('🚫 [RateLimitOverlay] Overlay activado:', {
          //   isVisible: this.isVisible,
          //   timeRemaining: this.timeRemaining
          // });
        } else if (state.isActive === false && state.timeRemaining === 0 && this.isVisible) {
          // Tiempo agotado, ejecutar acción
          //console.log('🚫 [RateLimitOverlay] Tiempo agotado, ejecutando acción');
          this.visibilityChange.emit(false); // Notificar que se oculta
          this.executeAction(state.isHome);
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  /**
   * Ejecuta la acción cuando se agota el tiempo
   */
  private executeAction(isHome: boolean): void {
    // console.log('🚫 [RateLimitOverlay] Tiempo agotado. Solo ocultando overlay, SIN recargar/redirigir');

    // IMPORTANTE: NO recargar ni redirigir automáticamente
    // porque puede generar nuevas peticiones mientras aún se está bloqueado en el backend
    // y crear un ciclo infinito de bloqueos
    this.isVisible = false;

    // El usuario puede recargar manualmente cuando quiera
    // O simplemente continuar navegando normalmente
  }

  /**
   * Convierte segundos a formato legible (minutos y segundos)
   */
  formatTime(seconds: number): string {
    if (seconds < 60) {
      // Solo segundos
      return `${seconds} segundo${seconds !== 1 ? 's' : ''}`;
    } else {
      // Minutos y segundos
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;

      if (remainingSeconds === 0) {
        // Solo minutos exactos
        return `${minutes} minuto${minutes !== 1 ? 's' : ''}`;
      } else {
        // Minutos y segundos
        return `${minutes} minuto${minutes !== 1 ? 's' : ''} y ${remainingSeconds} segundo${remainingSeconds !== 1 ? 's' : ''}`;
      }
    }
  }

  /**
   * Calcula el porcentaje de progreso para la barra circular
   */
  getProgressPercentage(): number {
    // Para el círculo, queremos que disminuya de 100 a 0
    return 100;
  }
}
